import { Component, OnDestroy, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { HttpParams } from '@angular/common/http';
import { Params, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { ProductService } from 'src/app/features/products/product.service';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import { MatTabGroup } from '@angular/material/tabs';
import { formatDate } from '@angular/common';
import * as moment from 'moment';
import { AdminViewService } from 'src/app/framework/services/admin-view.service';
@Component({
  selector: 'app-products-history',
  templateUrl: './products-history.component.html',
  styleUrls: ['./products-history.component.scss']
})
export class ProductsHistoryComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  data;
  columnDefs;
  rowData: any = [];
  rowSelection: string;
  selected: any = 'one month';
  isButtonDisabled:boolean
  //rowhistoryData: any = [];
  //rowhistorySelection: string;
  //private gridhistoryApi;
  //private gridhistoryColumnApi;
  private gridApi;
  private gridColumnApi;
  searchValue;
  searchhistoryValue;
  showEditProduct: boolean = false;
  selectedRows: any;
  showEditRetailer: boolean = false;
  showDeleteRetailer: boolean = false;
  toInactive: any = [];
  dateSelected: any;
  historyDays = [{ days: 30, value: 'Last 30 days' }, { days: 60, value: 'Last 60 days' }, { days: 90, value: 'Last 90 days' }];
  selectedDays = this.historyDays[0].days;
  constructor(private router: Router, private ProductService: ProductService,private adminViewServices:AdminViewService) {
    super();
    this.initGrid();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.adminViewServices.checkAdminVRole().subscribe((res) => {
      this.isButtonDisabled = res
    })
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  quickhistorySearch() {
    this.gridApi.setQuickFilter(this.searchhistoryValue);
  }

  showHistory(tabGroup: MatTabGroup) {
    //;
    tabGroup.selectedIndex = 2;
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    //setTimeout(() => { params.api.sizeColumnsToFit() }, 50);

  }

  initGrid() {
    var dt = new Date();
    dt.setDate(dt.getDate() - 30);
    let currentdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    let fromdate = formatDate(dt, 'yyyy-MM-dd', 'en');
    let params = new HttpParams()
      .set('start', fromdate)
      .set('end', currentdate)

    this.ProductService.addProductHistory(params).subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        this.rowData = resData;
        this.setGrid(resData);
      }
    })
  }



  // History grid initialization
  setGrid(data: any) {
    this.rowData = data;
    this.rowSelection = 'multi';
    this.columnDefs = [
      {field: 'modifiedDttm', headerName: 'Modified Date', cellRenderer: (data) => { 
        return moment(data.value).format('MM/DD/YYYY') }, sort: 'desc' },
      { field: 'displayName', headerName: 'Modified By' },    
      { field: 'role', headerName: 'Role' },
      { field: 'columnName', headerName: 'Column Name' },
      { field: 'currentValue', headerName: 'Current Value' },
      { field: 'previousValue', headerName: 'Previous Value' },
      { field: 'priceListName', headerName: 'PriceList Name' },
      { field: 'productHistoryId', headerName: 'Product History Id', hide: true  },
      { field: 'productId', headerName: 'Product Id', hide: true },
      { field: 'sku', headerName: 'SKU' },
      { field: 'modificationType', headerName: 'Changes' } 
    ];
  }

  exporthistoryData() {
    let header = this.columnDefs.map(columnDef => {
      let headerName = columnDef.headerName;
      return headerName;
      });
      let params: any = {
      fileName: 'Products-History.csv',
      //columnSeparator: ';',
      skipHeader: true,
      columnKeys: this.columnDefs.map(c => c.field || c.colId).filter(c => !!c)
      };
      params.customHeader = header.join(params.columnSeparator);
      params.processCellCallback = (cellParams) => {
      // 
      if(cellParams && cellParams.column.colId === '') {
        return ''; //apply your timestamp formatter 
      }else if(cellParams && cellParams.column.colId === 'modifiedDttm') {
        return moment(cellParams.value).format('MM/DD/YYYY')
      }
        else return cellParams.value // no formatting
      }
      this.gridApi.exportDataAsCsv(params);
  }
  onSelectionhistoryChanged(e) {

  }


  changehistory(e) {
    this.dateSelected = e.value;
    
    var dt = new Date();
    dt.setDate(dt.getDate() - this.dateSelected);
    let currentdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    let fromdate = formatDate(dt, 'yyyy-MM-dd', 'en');
    //alert(currentdate);
    let params = new HttpParams()
      .set('start', fromdate)
      .set('end', currentdate)
    this.ProductService.addProductHistory(params).subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        resData.forEach(x => {
          x.modifiedDttm = formatDate(x.modifiedDttm, 'MM-dd-yyyy', 'en');
        });
        this.rowData = resData;
        this.setGrid(resData);
      }
    })
  }




}
